<template>
  <RevCard
    class="mt-32 p-24 md:p-32"
    :data-test="`payout-${hyperwalletInformation.marketplace}`"
  >
    <div class="flex items-center">
      <h2 class="heading-2">
        {{ i18n(translations.title) }}
      </h2>
    </div>

    <StatusUnderReview v-if="status === 'PENDING'" class="mt-24" />
    <StatusInformationRequired
      v-else-if="status === 'NOT_ONBOARDED'"
      class="mt-24"
    />
    <StatusRejected
      v-else-if="status === 'INVALID' || status === 'BLOCKED'"
      class="mt-24"
    />
    <StatusVerified v-else-if="status === 'READY'" class="mt-24" />

    <RevButton
      v-if="!isVerified"
      class="mt-24"
      size="small"
      :to="{
        name: ROUTE_NAMES.ONBOARDING.OPTIONS.HYPERWALLET.KYB,
      }"
      variant="secondary"
    >
      {{ i18n(translations.providePaymentInfos) }}
    </RevButton>
  </RevCard>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { merchantsAPI } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevCard } from '@ds/components/Card'

import { ROUTE_NAMES } from '~/constants/routes'

import StatusInformationRequired from '../Status/StatusInformationRequired/StatusInformationRequired.vue'
import StatusRejected from '../Status/StatusRejected/StatusRejected.vue'
import StatusUnderReview from '../Status/StatusUnderReview/StatusUnderReview.vue'
import StatusVerified from '../Status/StatusVerified/StatusVerified.vue'

import translations from './PayoutMethodHyperwallet.translations'

const props = defineProps<{
  hyperwalletInformation: merchantsAPI.PaymentHyperwalletInformation
}>()

const i18n = useI18n()

const status = computed(() => props.hyperwalletInformation.status.code)
const isVerified = computed(() => status.value === 'READY')
</script>
